<h2 mat-dialog-title class="d-flex align-items-center justify-content-between">
  <span>URL &amp; Code Snippets</span>
  <button matIconButton mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <mat-tab-group>
    <!-- URL -->
    <mat-tab label="URL">
      <div class="d-flex align-items-start gap-2 pt-3">
        <pre class="url-snippet-dialog__code flex-grow-1">{{ dialogData.endpointData.url }}</pre>
        <button matIconButton (click)="copy(dialogData.endpointData.url, 'url')" [attr.aria-label]="copied() === 'url' ? 'Copied' : 'Copy URL'">
          <mat-icon>{{ copied() === "url" ? "check" : "content_copy" }}</mat-icon>
        </button>
      </div>
    </mat-tab>

    <!-- cURL -->
    <mat-tab label="cURL">
      <div class="d-flex align-items-start gap-2 pt-3">
        <pre class="url-snippet-dialog__code flex-grow-1">{{ curlSnippet() }}</pre>
        <button matIconButton (click)="copy(curlSnippet(), 'curl')" [attr.aria-label]="copied() === 'curl' ? 'Copied' : 'Copy cURL'">
          <mat-icon>{{ copied() === "curl" ? "check" : "content_copy" }}</mat-icon>
        </button>
      </div>
    </mat-tab>

    <!-- Python -->
    <mat-tab label="Python">
      <div class="d-flex align-items-start gap-2 pt-3">
        <pre class="url-snippet-dialog__code flex-grow-1">{{ pythonSnippet() }}</pre>
        <button matIconButton (click)="copy(pythonSnippet(), 'python')" [attr.aria-label]="copied() === 'python' ? 'Copied' : 'Copy Python'">
          <mat-icon>{{ copied() === "python" ? "check" : "content_copy" }}</mat-icon>
        </button>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
